import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import { Main, Content } from "../../../components/Layout";
import Wizard from "../../../components/Wizard";
import { Row, Col } from "react-bootstrap";
import api from "../../../services/api";
import EventDate from "../../../components/EventDate";
import Button from "../../../components/Button";
import { IntegerNumber, Currency, InputText } from "../../../components/Input";
import Slct from "../../../components/Slct";
import useFormat from "../../../hooks/utils/useFormat";
import Accordion from "../../../components/Accordion";
import TableResponsive from "../../../components/TableResponsive";
import Checkbox from "../../../components/Checkbox";
import SpoilerLink from "../../../components/SpoilerLink";
import IcLixo from "../../../components/Svg/IcLixo";
import TabNotification from "../../../components/TabNotification";
import TabContainer from "../../../components/TabNotification/TabContainer";
import ListItem from "../../../components/ListItem";
import Results from "../../../components/Results";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import { ModalConfirm, ModalBudget, ModalResourceTemplate } from "../../../components/Modal";
import { PrintPage } from "../../../components/PrintPage";
import style from "./style.module.scss";
import printRules from "../../../components/PrintRules/style.module.scss";
import Required from "../../../components/Required";
import { validateForm, validateStyle } from "../../../components/ValidateForm";
import PackageCard from "../../../components/PackageCard";
import Tooltip2 from "../../../components/Tooltip";
import DatePicker from "../../../components/DatePicker";
import ListSlct from "../../../components/ListSlct";

export default function Budget() {
  const { sortObject, formatReal, formatDate, stringToDate } = useFormat();
  const { commercialId, budgetSelect } = useParams();
  const { setbreadcrumb, config } = useWrapper();
  const [wizard, setwizard] = useState(0);
  const [packagesTab, setpackagesTab] = useState();

  const [categories, setcategories] = useState();
  const [providers, setproviders] = useState();
  const [packages, setpackages] = useState([]);
  const [singles, setsingles] = useState([]);
  const [preloadBudget, setpreloadBudget] = useState();
  const [loading, setloading] = useState();
  const [requestLoading, setrequestLoading] = useState();
  const [commercial, setcommercial] = useState();
  const [budgetValues, setbudgetValues] = useState();
  const [deleteds, setdeleteds] = useState({
    singles: [],
    packages: [],
  });
  const [budgets, setbudgets] = useState();
  const [dateProblem, setdateProblem] = useState();
  const navigate = useNavigate();
  const [templates, settemplates] = useState();
  const [reload, setreload] = useState();
  const [validateCustomComponents, setvalidateCustomComponents] = useState(false);
  const [mods, setmods] = useState();
  const [generatedValues, setgeneratedValues] = useState();

  useEffect(() => {
    if (!!budgetSelect) {
      (async function () {
        setloading(true);
        try {
          let { data: _categories } = await api.get("categories?only_attendance=0&paginate=false", config);
          const { data: _providers } = await api.get("providers?paginate=false", config);
          const { data: _templates } = await api.get("template-business?active=1", config);
          const { data: _budgets } = await api.get(`budget-colection?commercial_id=${commercialId}`, config);
          const { data: _contributions } = await api.get(`contribution?commercial_id=${commercialId}`, config);
          const { data: _removals } = await api.get(`removal?commercial_id=${commercialId}`, config);
          const { data: _generated } = await api.get(`total-amount-generated-per-commercial/${commercialId}`, config);

          if (!!budgetSelect && budgetSelect !== "new") {
            const { data: _budget } = await api.get(`budget-colection/${budgetSelect}`, config);
            setmods({
              contributions: _contributions,
              contributions_active: !!_budget?.aporte,
              removals: _removals,
              removals_active: !!_budget?.retirada,
            });
            setpreloadBudget(_budget);
            setcommercial({
              ..._budget.commercials,
              name: `${_budget.commercials?.course?.title} ${_budget.commercials?.year}.${
                _budget.commercials?.period
              } - ${_budget.commercials?.institution?.title}  ${
                !!_budget.commercials?.contract_number_legacy ? `(${_budget.commercials?.contract_number_legacy})` : ""
              }`,
            });
            setbudgetValues({
              title: _budget.title,
              description: _budget.description,
              active: !!_budget.active,
              main: !!_budget.main,
            });
            setpackages(
              _budget?.packageColection
                ?.filter(__package => !!__package.active)
                ?.map(__package => ({
                  id: __package.id,
                  active: __package.active,
                  advisory: __package.advisory,
                  events: __package.events.map(__event => ({
                    value: __event.id,
                    label: __event.name,
                    category_id: __event.category_id,
                  })),
                  number_trainees: __package.number_trainees,
                  reserve_fund: __package.reserve_fund,
                  title: __package.title,
                })),
            );
            setsingles(
              _budget?.packageSingleColection
                .filter(__single => !!__single.active)
                ?.map(__single => ({
                  advisory: __single.advisory,
                  category_id: __single.events.category_id,
                  label: __single.events.name,
                  reserve_fund: __single.reserve_fund,
                  value: __single.event_id,
                  id: __single.id,
                  number_trainees: __single.number_trainees,
                })),
            );

            _categories = _categories.map(__category => ({
              ...__category,
              event: __category.event.map(__event => {
                const _date = _budget.colectionsEventDates.find(
                  __event_date => __event_date.event_id === __event.id,
                )?.due_date;
                return {
                  ...__event,
                  ...(!!_date ? { date: stringToDate(_date) } : {}),
                };
              }),
            }));
          } else {
            const { data: _comercial } = await api.get(`commercial/${commercialId}`, config);
            setcommercial({
              ..._comercial,
              name: `${_comercial?.course?.title} ${_comercial?.year}.${_comercial?.period} - ${
                _comercial?.institution?.title
              } ${!!_comercial?.contract_number_legacy ? `(${_comercial?.contract_number_legacy})` : ""}`,
            });
          }
          setgeneratedValues(_generated);
          setproviders(
            _providers.map(__provider => ({
              value: __provider.id,
              label: __provider.name,
              resources: __provider.resources,
            })),
          );
          setcategories(_categories);
          setbudgets(_budgets);
          settemplates({
            category_selected: null,
            event_selected: null,
            data: _templates.map(__template => ({
              value: __template.id,
              label: __template.title,
              category_id: __template.category_id,
            })),
          });
        } catch (__err) {
          console.log("__err", __err);
          toast.error("Erro ao carregar dados.");
        }
        setloading(false);
      })();
    }
  }, [budgetSelect, reload]);

  useEffect(() => {
    if (commercial) {
      setbreadcrumb([
        { label: "Comercial", url: "/business" },
        { label: commercial?.name, url: `/business/feed/${commercialId}` },
        { label: budgetSelect ? budgetValues?.title || "(Sem Nome)" : "Novo Orçamento", title: true },
      ]);
    }
  }, [commercial, budgetValues?.title]);

  const [eventsValues, seteventsValues] = useState();
  useEffect(() => {
    const _selected_events = [...packages]
      ?.reduce(
        (__acc, __package) =>
          __acc.concat(
            __package.events.map(__event => ({
              ...__event,
              number_trainees: parseInt(__package.number_trainees) || 0,
            })),
          ),
        [],
      )
      ?.concat(
        [...singles].map(__event => ({
          ...__event,
          number_trainees: parseInt(__event.number_trainees) || 0,
        })),
      );

    let _selected_events_uniq = [];
    _selected_events.forEach(__event => {
      let _exists_event_i = _selected_events_uniq.findIndex(__event_uniq => __event_uniq.value === __event.value);

      if (_exists_event_i === -1) {
        _selected_events_uniq.push(__event);
      } else {
        _selected_events_uniq[_exists_event_i].number_trainees += __event.number_trainees;
      }
    });

    // Keep Resources
    _selected_events_uniq.forEach((__event, __event_i) => {
      let _resources = eventsValues.find(__event_value => __event_value.value === __event.value)?.resources || [];
      _selected_events_uniq[__event_i].resources = _resources;
    });

    // Preload Resources
    if (!!budgetSelect && budgetSelect !== "new" && !!preloadBudget) {
      _selected_events_uniq = _selected_events_uniq.map(__event => ({
        ...__event,
        resources: preloadBudget?.budgetColectionResource
          ?.filter(__resource => __resource.event_id === __event.value)
          ?.map(__resource => ({
            description: __resource.description,
            provider_id: __resource.provider_id,
            qtd: __resource.qtd,
            resource_id: __resource.resource_id,
            show: !!__resource.show,
            single_value: __resource.single_value,
            id: __resource.id,
          })),
      }));

      // Clear to just pass here one time (on load)
      let _has_package_collection = preloadBudget?.packageColection?.some(__package => !!__package.active);
      let _has_single_collection = preloadBudget?.packageSingleColection?.some(__single => !!__single.active);
      if (
        ((_has_package_collection && packages.length > 0) || !_has_package_collection) &&
        ((_has_single_collection && singles.length > 0) || !_has_single_collection)
      ) {
        setpreloadBudget();
      }
    }

    _selected_events_uniq = sortObject({
      array: _selected_events_uniq,
      key: "label",
    });
    seteventsValues(_selected_events_uniq);
  }, [packages, singles]);

  const saveBudget = async props => {
    const _is_valid = validate();
    if (!_is_valid) return;

    setrequestLoading(true);
    const _is_copy = props?.copy;
    const _is_main = props?.main || budgets?.length <= 0;
    const _is_delete = props?.delete;

    let _event_dates =
      categories.reduce((__acc, __category) => __acc.concat(__category.event.filter(__event => __event.date)), []) ||
      [];

    let _resources =
      eventsValues.reduce(
        (__acc, __event) =>
          __acc.concat(
            __event.resources.map(__resource => ({
              event_id: __event.value,
              resource_id: __resource.resource_id,
              provider_id: __resource.provider_id,
              description: __resource.description,
              single_value: __resource.single_value,
              qtd: __resource.qtd,
              show: __resource.show,
            })),
          ),
        [],
      ) || [];

    const _data_to_send = {
      main: _is_main ? 1 : 0,
      active: !_is_delete ? 1 : 0,
      title: `${budgetValues?.title} ${_is_copy ? "(Cópia)" : ""}`,
      description: budgetValues?.description || "",
      commercial_id: commercialId,
      aporte: mods?.contributions_active,
      retirada: mods?.removals_active,
      packages:
        packages
          ?.map(__package => ({
            ...(!!__package?.id && !_is_copy ? { id: __package.id } : {}),
            active: 1,
            advisory: __package.advisory,
            number_trainees: __package.number_trainees,
            reserve_fund: __package.reserve_fund,
            title: __package.title,
            events: __package.events?.map(__event => __event.value),
          }))
          .concat(
            deleteds.packages.map(__package => ({
              id: __package.id,
              active: 0,
            })),
          ) || [],
      single:
        singles
          ?.map(__single => ({
            ...(!!__single?.id && !_is_copy ? { id: __single.id } : {}),
            number_trainees: __single.number_trainees,
            advisory: __single.advisory,
            reserve_fund: __single.reserve_fund,
            event_id: __single.value,
            active: 1,
          }))
          .concat(
            deleteds?.singles?.map(__single => ({
              id: __single.id,
              active: 0,
            })),
          ) || [],
      eventDate: _event_dates?.map(__event => ({
        event_id: __event.id,
        due_date: __event.date,
      })),
      resources: _resources,
    };

    try {
      if (!budgetSelect || budgetSelect === "new" || _is_copy) {
        const { data: _budget_created } = await api.post("budget-colection", _data_to_send, config);
        navigate(`/business/budget/${commercialId}/${_budget_created.id}`);
        toast.success("Orçamento criado com sucesso!");
      } else {
        await api.put(`budget-colection/${budgetSelect}`, _data_to_send, config);
        if (_is_delete) {
          navigate(`/business/feed/${commercialId}`);
          toast.success("Orçamento apagado com sucesso!");
        } else {
          setreload(!reload);
          setwizard(0);
          toast.success("Orçamento editado com sucesso!");
        }
      }
      setbudgetValues({
        ...budgetValues,
        modal: null,
        main: _is_main,
      });
    } catch (__err) {
      console.log("__err", __err);
      toast.error("Problemas ao tentar criar orçamento!");
    } finally {
      setrequestLoading(false);
      setvalidateCustomComponents(false);
    }
  };

  const required = () => {
    let _errors = [];

    if (!budgetValues?.title) {
      _errors.push({
        name: "budgetValues.title",
      });
    }
    if (packages?.some(__package => !__package.number_trainees)) {
      _errors.push({
        name: "packages[].number_trainees",
      });
    }
    if (packages?.some(__package => !__package.title)) {
      _errors.push({
        name: "packages[].title",
      });
    }
    if (singles?.some(__package => !__package.number_trainees)) {
      _errors.push({
        name: "singles[].number_trainees",
      });
    }
    const _events_wo_date = categories
      ?.reduce((__acc, __category) => __acc.concat(__category.event), [])
      ?.filter(__event => eventsValues.some(__event_val => __event_val.value === __event.id))
      ?.some(__event => !__event.date);
    if (_events_wo_date) {
      _errors.push({
        name: "eventsValues[].date",
      });
    }

    if (packages?.length <= 0 && singles?.length <= 0) {
      toast.error("O Orçamento precisa ter ao menos um Pacote ou um Avulso.");
      return true;
    }

    _errors.forEach(__error => {
      document.querySelectorAll(`[data-name='${__error.name}']`).forEach(__el => {
        __el.classList.add("input-empty");
      });
    });

    if (_errors?.length > 0) {
      toast.error("Preencha todos os campos.");
      return true;
    }
  };

  const addTemplate = __ev => {
    const _event_values = [...eventsValues];
    const _event_index = _event_values?.findIndex(__event => __event.value === templates?.event_selected);
    _event_values[_event_index] = {
      ..._event_values[_event_index],
      resources: __ev?.templateBusinessResource?.map(__resource => ({
        description: __resource.description,
        id: __resource.id,
        provider_id: __resource.provider_id,
        qtd: parseInt(__resource.qtd),
        resource_id: __resource.resource_id,
        show: true,
        single_value: __resource.single_value,
      })),
    };
    seteventsValues(_event_values);
  };

  const advanceStep = __step => {
    const _is_valid = validate();
    if (!_is_valid) return;

    setwizard(__step);
  };

  const validate = __is_save => {
    const _is_valid_header = validateForm(document.getElementById("header_data"));
    const _is_valid_wizard = validateForm(document.getElementById(`wizard_${wizard}`));
    if (wizard === 1) {
      setvalidateCustomComponents(true);
    }
    return !!_is_valid_header && !!_is_valid_wizard;
  };

  return (
    <>
      <PrintPage
        has_logo={true}
        header={
          <>
            <h3 className={style.budget_title}>{budgetValues?.title}</h3>
            <p className={style.budget_description}>{budgetValues?.description}</p>
            <p className={style.budget_group}>{commercial?.name}</p>
          </>
        }
      >
        <Main className={printRules.small_font_on_print} style={validateStyle}>
          {!loading ? (
            <Content className={style.pt_0_on_print}>
              {budgets?.length > 0 && (
                <Row className={printRules.hide_on_print}>
                  <Col>
                    <div className="d-flex justify-content-end">
                      <Button
                        loading={requestLoading}
                        color="primary_ghost"
                        onClick={() => {
                          setbudgetValues({
                            ...budgetValues,
                            modal: {
                              type: "others",
                            },
                          });
                        }}
                      >
                        Outras Versões
                      </Button>
                      {budgetSelect !== "new" && (
                        <Button
                          loading={requestLoading}
                          color="primary_ghost"
                          onClick={() => {
                            window.print();
                          }}
                        >
                          Imprimir
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <Row className={`mb-4 ${printRules.hide_on_print}`} id="header_data">
                <Col sm={4}>
                  <label>
                    Nome do Orçamento <Required />
                  </label>
                  <InputText
                    required={true}
                    value={budgetValues?.title}
                    onChange={__ev => {
                      setbudgetValues({
                        ...budgetValues,
                        title: __ev.target.value,
                      });
                    }}
                  />
                </Col>
                <Col>
                  <label>Descrição</label>
                  <InputText
                    value={budgetValues?.description}
                    onChange={__ev => {
                      setbudgetValues({
                        ...budgetValues,
                        description: __ev.target.value,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Wizard
                className={printRules.hide_on_print}
                selected={wizard + 1}
                options={[
                  { label: "Formação de Pacotes", onClick: () => advanceStep(0) },
                  { label: "Custos / Orçamento", onClick: () => advanceStep(1) },
                ]}
              />
              <div className={`mt-4 ${style.m_0_on_print}`}>
                <div className={`${wizard === 0 ? printRules.hide_on_print : "d-none"} `} id="wizard_0">
                  <Row>
                    <Col sm={7}>
                      <div>
                        <h2 className="form-title mb-0">Pacotes</h2>
                        <p className="small-label">
                          Para otimizar o processo de vendas, recomendamos a criação de 2 pacotes principais: Um mais
                          básico e outro completo. Além disso, você também pode criar eventos de adesão avulsa que podem
                          ser vendidos em qualquer momento durante a jornada da turma na empresa.
                        </p>
                        {packages?.map((__package, __package_i) => (
                          <div
                            style={{
                              borderLeft: "var(--color-grey-3) 3px solid",
                              paddingLeft: "1rem",
                              marginBottom: "1rem",
                            }}
                          >
                            <Row className="mb-1">
                              <Col>
                                <label>
                                  Nome <Required />
                                </label>
                                <InputText
                                  required={true}
                                  value={__package.title}
                                  onChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[__package_i].title = __ev.target.value;
                                    setpackages(_packages);
                                  }}
                                />
                              </Col>
                              <Col>
                                <label>
                                  Formandos <Required />
                                </label>
                                <IntegerNumber
                                  required={true}
                                  value={__package.number_trainees}
                                  valueChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[__package_i].number_trainees = parseInt(__ev);
                                    setpackages(_packages);
                                  }}
                                  maxlength="4"
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <label>Eventos Inclusos</label>
                                <Slct
                                  required={true}
                                  options={
                                    categories
                                      ?.reduce((__acc, __category) => __acc.concat(__category.event), [])
                                      .map(__event => ({
                                        label: __event.name,
                                        value: __event.id,
                                        category_id: __event.category_id,
                                      })) || []
                                  }
                                  placeholder="..."
                                  isMulti="true"
                                  value={__package?.events || []}
                                  onChange={__ev => {
                                    let _packages = [...packages];
                                    _packages[__package_i].events = __ev;
                                    setpackages(_packages);
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col className="text-end">
                                <Button
                                  size="sm"
                                  className="mt-3"
                                  color="error"
                                  onClick={() => {
                                    let _packages = [...packages];
                                    if (!!__package.id) {
                                      let _deleteds_packages = [...deleteds.packages];
                                      _deleteds_packages.push(_packages[__package_i]);
                                      setdeleteds({
                                        ...deleteds,
                                        packages: _deleteds_packages,
                                      });
                                    }
                                    _packages.splice(__package_i, 1);
                                    setpackages(_packages);
                                  }}
                                >
                                  Remover Pacote {__package.title || ""}
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        ))}
                        <div>
                          <Button
                            size="sm"
                            onClick={() => {
                              setpackages([
                                ...packages,
                                {
                                  title: "",
                                  number_trainees: null,
                                  events: [],
                                  active: true,
                                  advisory: null,
                                  reserve_fund: null,
                                },
                              ]);
                            }}
                          >
                            Adicionar Pacote
                          </Button>
                        </div>
                      </div>
                      <div className="divisor mt-4 mb-4"></div>
                      <div>
                        <h2 className="form-title mb-0">Eventos Avulsos</h2>
                        <p className="small-label">
                          Selecione Eventos que podem ser selecionados sem possuir vínculo com pacotes.
                        </p>
                        <Slct
                          options={
                            categories
                              ?.reduce((__acc, __category) => __acc.concat(__category.event), [])
                              .map(__event => ({
                                label: __event.name,
                                value: __event.id,
                                category_id: __event.category_id,
                                advisory: null,
                                reserve_fund: null,
                              })) || []
                          }
                          placeholder="..."
                          isMulti="true"
                          value={singles || []}
                          onChange={__ev => {
                            let _deleteds = singles
                              ?.filter(__val => !__ev.includes(__val))
                              ?.filter(__single => !!__single.id);
                            if (_deleteds.length > 0) {
                              let _deleteds_singles = [...deleteds.singles];
                              _deleteds_singles = _deleteds_singles.concat(_deleteds);
                              setdeleteds({
                                ...deleteds,
                                singles: _deleteds_singles,
                              });
                            }
                            setsingles(__ev);
                          }}
                        />
                      </div>
                      <div className="mt-2">
                        {singles?.map((__single, __single_i) => (
                          <EventDate
                            required={true}
                            data-value={__single.number_trainees}
                            isSingle={true}
                            name={__single.label}
                            number={__single.number_trainees}
                            onChangeNumber={__ev => {
                              let _singles = [...singles];
                              _singles[__single_i].number_trainees = parseInt(__ev);
                              setsingles(_singles);
                            }}
                            suffix={" formandos"}
                            placeholder="0 formandos"
                          />
                        ))}
                      </div>
                    </Col>
                    <Col>
                      <h2 className="form-title mb-0">Data dos Eventos</h2>
                      <p className="small-label">
                        Você deve selecionar as datas dos eventos que serão disponibilizados em nossos pacotes.
                        Aconselhamos que a data selecionada não ultrapasse a data da última parcela.
                      </p>
                      {categories?.map((__category, __category_i) => {
                        return (
                          <>
                            {eventsValues.find(__event => __event.category_id === __category.id) && (
                              <p className="mt-2 mb-1 fw-bold">{__category.name}</p>
                            )}
                            {__category.event?.map((__event, __event_i) => {
                              let _is_selected = eventsValues.find(
                                __selected_event => __selected_event.value === __event.id,
                              );

                              return (
                                <>
                                  {!!_is_selected && (
                                    <>
                                      <EventDate
                                        data-value={__event.date}
                                        required={true}
                                        name={__event.name}
                                        date={__event.date}
                                        onChangeDate={async __ev => {
                                          let _categories = [...categories];
                                          _categories[__category_i].event[__event_i].date = __ev;
                                          setcategories(_categories);
                                        }}
                                      />
                                    </>
                                  )}
                                </>
                              );
                            })}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
                <div className={`${wizard === 1 ? "d-block" : printRules.hide_not_print} `} id="wizard_1">
                  <div className="mb-2">
                    <h2 className="form-title mb-0">Recursos por Evento</h2>
                    <p className={`small-label mb-0 ${printRules.hide_on_print}`}>
                      Você deve selecionar os recursos e seus valores relacionados aos eventos.
                    </p>
                  </div>
                  <Accordion>
                    {eventsValues?.map((__event, __event_i) => {
                      const _value_total = __event?.resources?.reduce(
                        (__acc, __resource) => __acc + (__resource.single_value || 0) * (__resource.qtd || 0),
                        0,
                      );
                      const _resources =
                        categories
                          ?.find(__category => __category.id === __event.category_id)
                          ?.resource?.map(__resource => ({
                            value: __resource.id,
                            label: __resource.name,
                          })) || [];
                      return (
                        <Accordion.Item
                          eventKey={`${__event_i + 1}`}
                          className={`${__event_i > 0 ? printRules.avoid_break_on_print : ""}`}
                          data-new-component={true}
                          data-has-error={
                            __event?.resources?.some(__resource => !__resource?.resource_id) &&
                            !!validateCustomComponents
                          }
                        >
                          <Accordion.Header>
                            <span>
                              {__event.label}
                              <p className="small-label mb-0">
                                {" "}
                                <b>{__event.number_trainees}</b> Formandos
                              </p>
                            </span>
                            <Accordion.Extras>
                              <span>{formatReal(_value_total)}</span>
                              {__event.number_trainees ? (
                                <span>{`${formatReal(_value_total / __event.number_trainees)} / formando`}</span>
                              ) : (
                                <></>
                              )}
                            </Accordion.Extras>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Button
                              className={`mb-3 ${printRules.hide_on_print}`}
                              color="primary_ghost"
                              size="sm"
                              onClick={() => {
                                settemplates({
                                  ...templates,
                                  category_selected: __event.category_id,
                                  event_selected: __event.value,
                                });
                              }}
                            >
                              Carregar Modelo de Orçamento
                            </Button>
                            {/* <div className="divisor mt-4 mb-4"></div> */}
                            <TableResponsive
                              emptyMsg="Nenhum recurso cadastrado neste evento."
                              table={{
                                head: [
                                  { data: "Exibir", className: printRules.hide_on_print },
                                  { data: "Recurso", className: style.padding_left_on_print },
                                  { data: "Fornecedor" },
                                  { data: "Quantidade" },
                                  { data: "Valor Unitário" },
                                  { data: "Total" },
                                  { data: "Espec." },
                                  { data: "", className: printRules.hide_on_print },
                                ],
                                body:
                                  __event?.resources?.map((__resource, __resource_i) => ({
                                    show_spoiler: !!__resource?.description,
                                    data: [
                                      {
                                        element: (
                                          <Checkbox
                                            checked={__resource.show}
                                            onChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].show =
                                                __ev.target.checked;
                                              seteventsValues(_eventsValues);
                                            }}
                                          />
                                        ),
                                        className: printRules.hide_on_print,
                                      },
                                      {
                                        element: (
                                          <Slct
                                            required={true}
                                            placeholder="..."
                                            value={__resource.resource_id}
                                            onChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].resource_id = __ev.value;
                                              eventsValues[__event_i].resources[__resource_i].provider_id = null;
                                              seteventsValues(_eventsValues);
                                            }}
                                            options={_resources}
                                          />
                                        ),
                                        className: style.padding_left_on_print,
                                      },
                                      {
                                        element: (
                                          <Slct
                                            placeholder="..."
                                            value={__resource.provider_id}
                                            onChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].provider_id = __ev.value;
                                              seteventsValues(_eventsValues);
                                            }}
                                            options={
                                              providers.filter(__provider =>
                                                __provider.resources.some(
                                                  __resource_provider =>
                                                    __resource_provider.id === __resource.resource_id,
                                                ),
                                              ) || []
                                            }
                                          />
                                        ),
                                      },
                                      {
                                        element: (
                                          <IntegerNumber
                                            value={__resource.qtd}
                                            valueChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].qtd = parseInt(__ev);
                                              seteventsValues(_eventsValues);
                                            }}
                                            maxlength="4"
                                            style={{ width: "75px" }}
                                            allowNegative={false}
                                          />
                                        ),
                                      },
                                      {
                                        element: (
                                          <Currency
                                            value={__resource.single_value}
                                            valueChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].single_value = __ev;
                                              seteventsValues(_eventsValues);
                                            }}
                                            style={{ width: "140px" }}
                                            allowNegative={false}
                                          />
                                        ),
                                      },
                                      {
                                        element: (
                                          <span>
                                            {formatReal((__resource.qtd || 0) * (__resource.single_value || 0))}
                                          </span>
                                        ),
                                      },
                                      {
                                        element: <SpoilerLink text="" bold={!!__resource.description} />,
                                        className: printRules.hide_on_print,
                                        id: `description-${__event_i}-${__resource_i}`,
                                        spoiler: (
                                          <InputText
                                            placeholder="Descrição"
                                            value={__resource.description}
                                            onChange={__ev => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources[__resource_i].description =
                                                __ev.target.value;
                                              seteventsValues(_eventsValues);
                                            }}
                                          />
                                        ),
                                      },
                                      {
                                        element: (
                                          <button
                                            className="simple-ico"
                                            onClick={() => {
                                              let _eventsValues = [...eventsValues];
                                              eventsValues[__event_i].resources.splice(__resource_i, 1);
                                              seteventsValues(_eventsValues);
                                            }}
                                          >
                                            <IcLixo />
                                          </button>
                                        ),
                                      },
                                    ],
                                  })) || [],
                              }}
                            />
                            <p className={`m-0 mt-2 op-5 ${printRules.hide_not_print}`}>
                              <span className="fw-bold">Recursos não adicionados: </span>
                              {_resources
                                ?.filter(__resource => {
                                  const _event_selected = __event?.resources?.find(
                                    __selected_resource => __selected_resource.resource_id === __resource.value,
                                  );
                                  return !_event_selected;
                                })
                                ?.map((__resource, __resource_i) => {
                                  return (
                                    <>
                                      {__resource_i > 0 ? ", " : ""}
                                      {__resource.label}
                                    </>
                                  );
                                })}
                            </p>

                            {/*  */}
                            <Button
                              size="sm"
                              className={printRules.hide_on_print}
                              onClick={() => {
                                let _events_values = [...eventsValues];
                                _events_values[__event_i].resources.push({
                                  show: true,
                                  resource_id: null,
                                  provider_id: null,
                                  qtd: null,
                                  single_value: null,
                                  description: "",
                                });
                                seteventsValues(_events_values);
                              }}
                            >
                              Adicionar Recurso
                            </Button>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>
                  <div className="divisor mt-4 mb-4"></div>

                  <div className={printRules.avoid_break_on_print}>
                    <div className="mb-2">
                      <h2 className="form-title mb-0">Pacotes & Custos Extras</h2>
                      <p className={`small-label mb-0 ${printRules.hide_on_print}`}>
                        Aqui você definirá os valores de Assessoria e Fundo de Reserva. Também visualizará um resumo dos
                        valores de cada pacote e avulsos.
                      </p>
                    </div>

                    {(packages.length > 0 || singles.length > 0) && (
                      <>
                        <TabNotification
                          options={packages
                            ?.map((__package, __package_i) => ({
                              id: __package_i + 1,
                              label: __package.title,
                              value: __package.number_trainees,
                              show: packages?.length > 0,
                            }))
                            .concat([
                              {
                                id: -1,
                                label: "Avulsos",
                                value: null,
                                show: singles?.length > 0,
                              },
                            ])}
                          setActive={setpackagesTab}
                          active={packagesTab}
                          init={null}
                          className={printRules.hide_on_print}
                        />

                        {packages.map((__package, __package_i) => (
                          <>
                            {(() => {
                              let _acc_package =
                                ((__package?.advisory || 0) + (__package?.reserve_fund || 0)) *
                                (__package?.number_trainees || 0);

                              return (
                                <TabContainer
                                  className={`${packagesTab !== __package_i + 1 ? printRules.hide_not_print : ""} ${
                                    printRules.avoid_break_on_print
                                  }`}
                                >
                                  <>
                                    <h2 className="form-title mb-0">{__package?.title || "Avulsos"}</h2>
                                    <p className="small-label">
                                      Quantidade de parcelas possíveis: {commercial?.min_payment}x
                                    </p>
                                    <PackageCard>
                                      {__package?.events?.map((__event, __event_i) => {
                                        const _event_values = eventsValues.find(
                                          __event_value => __event_value.value === __event.value,
                                        );
                                        const _event_sum = _event_values?.resources?.reduce(
                                          (__acc, __resource) =>
                                            __acc + (__resource.qtd || 0) * (__resource.single_value || 0),
                                          0,
                                        );
                                        const _package_event_value =
                                          (_event_sum / _event_values?.number_trainees || 0) *
                                          Number(__package?.number_trainees);
                                        _acc_package += _package_event_value;

                                        return (
                                          <>
                                            <ListItem>
                                              <span>
                                                <span>{__event.label}</span>
                                                <p className="small-label mb-0">
                                                  <b>{__package.number_trainees}</b> Formandos
                                                </p>
                                              </span>
                                              <span>{formatReal(_package_event_value)}</span>
                                            </ListItem>
                                          </>
                                        );
                                      })}
                                      <ListItem>
                                        <span>
                                          <span>Assessoria</span>
                                          <p className="small-label mb-0">
                                            <b>{__package.number_trainees}</b> Formandos
                                          </p>
                                        </span>
                                        <span>
                                          <Currency
                                            label="Por Formando"
                                            className={style.inputPrint}
                                            value={__package?.advisory}
                                            valueChange={__ev => {
                                              let _packages = [...packages];
                                              _packages[__package_i].advisory = __ev;
                                              setpackages(_packages);
                                            }}
                                            style={{ width: "220px", textAlign: "right" }}
                                            allowNegative={false}
                                          />
                                        </span>
                                      </ListItem>
                                      <ListItem>
                                        <span>
                                          <span>Fundo de Reserva</span>
                                          <p className="small-label mb-0">
                                            <b>{__package.number_trainees}</b> Formandos
                                          </p>
                                        </span>
                                        <span>
                                          <Currency
                                            label="Por Formando"
                                            className={style.inputPrint}
                                            value={__package?.reserve_fund}
                                            valueChange={__ev => {
                                              let _packages = [...packages];
                                              _packages[__package_i].reserve_fund = __ev;
                                              setpackages(_packages);
                                            }}
                                            style={{ width: "220px", textAlign: "right" }}
                                            allowNegative={false}
                                          />
                                        </span>
                                      </ListItem>
                                      <Row className="text-right mt-4">
                                        <Col md={{ span: 6, offset: 6 }}>
                                          <Results
                                            rows={[
                                              {
                                                label: (
                                                  <>
                                                    Total <span className="small-label">( Pacote )</span>
                                                  </>
                                                ),
                                                value: formatReal(_acc_package),
                                                type: "dark",
                                              },
                                              {
                                                label: (
                                                  <>
                                                    Por formando{" "}
                                                    <span className="small-label">
                                                      ( <b>{__package.number_trainees}</b> )
                                                    </span>
                                                  </>
                                                ),
                                                value: formatReal(_acc_package / __package?.number_trainees),
                                              },
                                              {
                                                label: "",
                                                value: (
                                                  <span className="op-5">
                                                    {`${commercial?.min_payment || 0}x de `}
                                                    {formatReal(
                                                      _acc_package /
                                                        __package?.number_trainees /
                                                        commercial?.min_payment,
                                                    )}
                                                  </span>
                                                ),
                                              },
                                            ]}
                                          />
                                        </Col>
                                      </Row>
                                    </PackageCard>
                                  </>
                                </TabContainer>
                              );
                            })()}
                          </>
                        ))}

                        <TabContainer
                          className={`${packagesTab !== -1 ? printRules.hide_not_print : ""} ${
                            printRules.avoid_break_on_print
                          }`}
                        >
                          <h2 className="form-title mb-0">Avulsos</h2>
                          <p className="small-label">Quantidade de parcelas possíveis: {commercial?.min_payment}x</p>
                          <PackageCard>
                            {singles?.map((__single, __single_i) => {
                              const _event = eventsValues?.find(
                                __event_value => __event_value.value === __single.value,
                              );
                              const _event_value = _event?.resources?.reduce(
                                (__acc, __resource) => __acc + (__resource.qtd || 0) * (__resource.single_value || 0),
                                0,
                              );
                              const _single_value =
                                (_event_value / (_event?.number_trainees || 0)) *
                                  parseInt(__single.number_trainees || 0) || 0;
                              const _single_total =
                                _single_value +
                                (__single.advisory || 0) * (__single.number_trainees || 0) +
                                (__single.reserve_fund || 0) * (__single.number_trainees || 0);

                              return (
                                <div>
                                  {__single_i !== 0 && <div className="divisor mt-4 mb-4"></div>}
                                  <ListItem color="dark_ghost">
                                    <span>
                                      <span>{__single.label}</span>
                                      <p className="small-label mb-0">
                                        <b>{__single.number_trainees}</b> Formandos
                                      </p>
                                    </span>
                                    <span>{formatReal(_single_value)}</span>
                                  </ListItem>
                                  <ListItem>
                                    <span>
                                      <span>Assessoria</span>
                                      <p className="small-label mb-0">
                                        <b>{__single.number_trainees}</b> Formandos
                                      </p>
                                    </span>
                                    <span>
                                      <Currency
                                        label="Por Formando"
                                        className={style.inputPrint}
                                        value={__single?.advisory}
                                        valueChange={__ev => {
                                          let _singles = [...singles];
                                          _singles[__single_i].advisory = __ev;
                                          setsingles(_singles);
                                        }}
                                        style={{ width: "220px", textAlign: "right" }}
                                        allowNegative={false}
                                      />
                                    </span>
                                  </ListItem>
                                  <ListItem>
                                    <span>
                                      <span>Fundo de Reserva</span>
                                      <p className="small-label mb-0">
                                        <b>{__single.number_trainees}</b> Formandos
                                      </p>
                                    </span>
                                    <span>
                                      <Currency
                                        label="Por Formando"
                                        className={style.inputPrint}
                                        value={__single?.reserve_fund}
                                        valueChange={__ev => {
                                          let _singles = [...singles];
                                          _singles[__single_i].reserve_fund = __ev;
                                          setsingles(_singles);
                                        }}
                                        style={{ width: "220px", textAlign: "right" }}
                                        allowNegative={false}
                                      />
                                    </span>
                                  </ListItem>
                                  <Row className="text-right mt-4">
                                    <Col md={{ span: 6, offset: 6 }}>
                                      <Results
                                        rows={[
                                          {
                                            label: (
                                              <>
                                                Total <span className="small-label">( Avulso )</span>
                                              </>
                                            ),
                                            value: formatReal(_single_total),
                                            type: "dark",
                                          },
                                          {
                                            label: (
                                              <>
                                                Por formando{" "}
                                                <span className="small-label">
                                                  ( <b>{__single?.number_trainees}</b> )
                                                </span>
                                              </>
                                            ),
                                            value: formatReal(_single_total / (__single.number_trainees || 0)),
                                          },
                                          {
                                            label: "",
                                            value: (
                                              <span className="op-5">
                                                {`${commercial?.min_payment}x de `}
                                                {formatReal(
                                                  _single_total /
                                                    (__single.number_trainees || 0) /
                                                    commercial?.min_payment,
                                                )}
                                              </span>
                                            ),
                                          },
                                        ]}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              );
                            })}
                          </PackageCard>
                        </TabContainer>
                        {!!commercial?.is_class && (
                          <div className="-print-avoid-break">
                            <Row className="mb-2">
                              <Col>
                                <div className="divisor mt-4 mb-3"></div>
                                <h3 className="mini-title">Aportes & Retiradas</h3>
                                <p className="small-label m-0">
                                  Caso o aporte não seja benefício de todos os formandos, selecione os beneficiados.
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={12}>
                                <Accordion>
                                  <Accordion.Item eventKey="aportes">
                                    <Accordion.Header>
                                      <Tooltip2 tip="Usar no Cálculo do Financeiro">
                                        <div className="d-flex align-items-center">
                                          <Checkbox
                                            colorScheme="accordion"
                                            checked={!!mods?.contributions_active}
                                            onChange={__ev => {
                                              setmods({
                                                ...mods,
                                                contributions_active: __ev.target.checked,
                                              });
                                            }}
                                          />
                                        </div>
                                      </Tooltip2>
                                      <span className="ml-2">
                                        Aportes{" "}
                                        <p className="small-label mb-0">
                                          {!!mods?.contributions_active ? "Está" : "Não está"} fazendo parte do cálculo
                                          do financeiro
                                        </p>
                                      </span>
                                      <Accordion.Extras>
                                        <p className="m-0">
                                          {formatReal(
                                            mods?.contributions?.reduce(
                                              (__acc_contribution, __contribution) =>
                                                __acc_contribution + __contribution.value,
                                              0,
                                            ) || 0,
                                          )}
                                        </p>
                                      </Accordion.Extras>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <TableResponsive
                                        emptyMsg="Nenhum aporte cadastrado."
                                        table={{
                                          head: [
                                            { data: "Tipo" },
                                            { data: "Descrição" },
                                            { data: "Data" },
                                            { data: "Valor" },
                                            { data: "Protocolo" },
                                            { data: "" },
                                          ],
                                          body:
                                            mods?.contributions?.map((__contribution, __contribution_i) => ({
                                              data: [
                                                {
                                                  element: (
                                                    <InputText
                                                      placeholder="Tipo de Aporte"
                                                      value={__contribution?.type}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <InputText
                                                      placeholder="Descrição"
                                                      value={__contribution?.description}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <DatePicker
                                                      className="form-control w-100"
                                                      selected={__contribution?.due_date || ""}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <Currency value={__contribution?.value || ""} disabled={true} />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <IntegerNumber
                                                      value={__contribution?.protocol_attendance}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                              ],
                                              extraRow: [
                                                {
                                                  element: (
                                                    <ListSlct
                                                      values={
                                                        __contribution.trainees?.map(__trainee => ({
                                                          value: __trainee?.id,
                                                          label: __trainee?.name,
                                                        })) || []
                                                      }
                                                      allLabel="Todos os Formandos"
                                                    />
                                                  ),
                                                },
                                              ],
                                            })) || [],
                                        }}
                                      />
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </Col>
                            </Row>
                            <Row className="mt-2">
                              <Col sm={12}>
                                <Accordion>
                                  <Accordion.Item eventKey="retiradas">
                                    <Accordion.Header>
                                      <Tooltip2 tip="Usar no Cálculo do Financeiro">
                                        <div className="d-flex align-items-center">
                                          <Checkbox
                                            colorScheme="accordion"
                                            checked={!!mods?.removals_active}
                                            onChange={__ev => {
                                              setmods({
                                                ...mods,
                                                removals_active: __ev.target.checked,
                                              });
                                            }}
                                          />
                                        </div>
                                      </Tooltip2>
                                      <span className="ml-2">
                                        Retiradas{" "}
                                        <p className="small-label mb-0">
                                          {!!mods?.removals_active ? "Está" : "Não está"} fazendo parte do cálculo do
                                          financeiro
                                        </p>
                                      </span>
                                      <Accordion.Extras>
                                        <p className="m-0">
                                          {formatReal(
                                            mods?.removals?.reduce(
                                              (__acc_removal, __removal) => __acc_removal + __removal.value,
                                              0,
                                            ) || 0,
                                          )}
                                        </p>
                                      </Accordion.Extras>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <TableResponsive
                                        emptyMsg="Nenhum aporte cadastrado."
                                        table={{
                                          head: [
                                            { data: "Tipo" },
                                            { data: "Descrição" },
                                            { data: "Data" },
                                            { data: "Valor" },
                                            { data: "Protocolo" },
                                            { data: "" },
                                          ],
                                          body:
                                            mods?.removals?.map((__removal, __removal_i) => ({
                                              data: [
                                                {
                                                  element: (
                                                    <InputText
                                                      placeholder="Tipo de Aporte"
                                                      value={__removal?.type}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <InputText
                                                      placeholder="Descrição"
                                                      value={__removal?.description}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: (
                                                    <DatePicker
                                                      className="form-control w-100"
                                                      selected={__removal?.due_date || ""}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                                {
                                                  element: <Currency value={__removal?.value || ""} disabled={true} />,
                                                },
                                                {
                                                  element: (
                                                    <IntegerNumber
                                                      value={__removal?.protocol_attendance}
                                                      disabled={true}
                                                    />
                                                  ),
                                                },
                                              ],
                                              extraRow: [
                                                {
                                                  element: (
                                                    <ListSlct
                                                      values={
                                                        __removal.trainees?.map(__trainee => ({
                                                          value: __trainee?.id,
                                                          label: __trainee?.name,
                                                        })) || []
                                                      }
                                                      allLabel="Todos os Formandos"
                                                    />
                                                  ),
                                                },
                                              ],
                                            })) || [],
                                        }}
                                      />
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </Col>
                            </Row>
                          </div>
                        )}
                        <Row className="text-right mt-4">
                          <Col md={{ span: 6, offset: 6 }}>
                            <h3 className="form-title mb-2">Resumo do Orçamento</h3>
                            {(() => {
                              const _all_resources_sum =
                                eventsValues
                                  ?.reduce((__acc, __event_value) => __acc.concat(__event_value?.resources || []), [])
                                  ?.reduce(
                                    (__acc, __resource) =>
                                      __acc + (__resource?.qtd || 0) * (__resource?.single_value || 0),
                                    0,
                                  ) || 0;

                              const _all_singles_extras =
                                singles?.reduce(
                                  (__acc, __single) =>
                                    __acc +
                                    (__single.advisory || 0) * (__single.number_trainees || 0) +
                                    (__single.reserve_fund || 0) * (__single.number_trainees || 0),
                                  0,
                                ) || 0;

                              const _all_packages_extras =
                                packages?.reduce(
                                  (__acc, __package) =>
                                    __acc +
                                    (__package.advisory || 0) * (__package.number_trainees || 0) +
                                    (__package.reserve_fund || 0) * (__package.number_trainees || 0),
                                  0,
                                ) || 0;

                              const _sum_total = _all_resources_sum + _all_singles_extras + _all_packages_extras;

                              const _all_contributions = mods?.contributions?.reduce(
                                (__acc_contribution, __contribution) =>
                                  __acc_contribution + (__contribution?.value || 0),
                                0,
                              );
                              const _all_removals = mods?.removals?.reduce(
                                (__acc_removal, __removal) => __acc_removal + (__removal?.value || 0),
                                0,
                              );

                              const _total_espected =
                                _sum_total -
                                (!!mods?.contributions_active ? _all_contributions : 0) +
                                (!!mods?.removals_active ? _all_removals : 0);
                              const _total_generated = generatedValues?.totalGeneratedRaw?.totalGeneratedRaw || 0;
                              const _total_paid = generatedValues?.totalPaid?.totalPaidRaw || 0;

                              // mods?.contributions_active

                              return !!commercial?.is_class ? (
                                <>
                                  <Results
                                    rows={[
                                      {
                                        label: "Custo Solenidades",
                                        value: formatReal(_sum_total),
                                        type: "dark",
                                      },
                                      ...(!!mods?.contributions_active
                                        ? [
                                            {
                                              label: "Aportes",
                                              value: `- ${formatReal(_all_contributions)}`,
                                            },
                                          ]
                                        : []),
                                      ...(!!mods?.removals_active
                                        ? [
                                            {
                                              label: "Retiradas",
                                              value: `+ ${formatReal(_all_removals)}`,
                                            },
                                          ]
                                        : []),
                                      ...(!!mods?.contributions_active || mods?.removals_active
                                        ? [
                                            {
                                              label: <b>Total Esperado</b>,
                                              value: formatReal(_total_espected),
                                              type: "dark",
                                            },
                                          ]
                                        : []),
                                      {
                                        label: "Total Gerado",
                                        value: formatReal(_total_generated),
                                        type: "transparent",
                                      },
                                      {
                                        label: <b>Resultado Financeiro</b>,
                                        value: `${_total_espected - _total_generated > 0 ? "-" : ""} ${formatReal(
                                          _total_espected - _total_generated,
                                        )}`,
                                        type: "dark",
                                      },
                                      {
                                        label: "Total Pago",
                                        value: formatReal(_total_paid),
                                        type: "transparent",
                                      },
                                    ]}
                                  />
                                  <div class="small-label mt-2">
                                    Total Gerado e Total Pago não contabilizam descontos, taxas, multas e juros.
                                  </div>
                                </>
                              ) : (
                                <Results
                                  rows={[
                                    {
                                      label: "Custo Solenidades",
                                      value: formatReal(_sum_total),
                                      type: "dark",
                                    },
                                  ]}
                                />
                              );
                            })()}
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                </div>
                <div className={printRules.hide_on_print}>
                  <div className={`d-flex justify-content-between mt-4`}>
                    <div className="d-flex align-items-end">
                      {!budgetValues?.main && budgetSelect !== "new" ? (
                        <Button
                          loading={requestLoading}
                          color="error_ghost"
                          onClick={() => {
                            setbudgetValues({
                              ...budgetValues,
                              modal: {
                                type: "delete",
                              },
                            });
                          }}
                        >
                          Apagar
                        </Button>
                      ) : (
                        <>
                          {!!budgetValues?.main && (
                            <p className="small-label m-0">
                              Este é o <b>Orçamento Principal</b>.
                            </p>
                          )}
                        </>
                      )}
                    </div>
                    <div className="d-flex justify-content-end">
                      {wizard === 0 ? (
                        <Button
                          color="primary_ghost"
                          loading={requestLoading}
                          onClick={() => {
                            advanceStep(1);
                          }}
                        >
                          Avançar
                        </Button>
                      ) : (
                        <Button
                          color="primary_ghost"
                          loading={requestLoading}
                          onClick={() => {
                            advanceStep(0);
                          }}
                        >
                          Voltar
                        </Button>
                      )}
                      {wizard === 1 && (
                        <>
                          {!!budgetSelect && budgetSelect !== "new" && (
                            <Button
                              loading={requestLoading}
                              onClick={() => {
                                const _is_valid = validate();
                                if (!_is_valid) return;
                                setbudgetValues({
                                  ...budgetValues,
                                  modal: {
                                    type: "save",
                                    copy: true,
                                  },
                                });
                              }}
                            >
                              Salvar Cópia
                            </Button>
                          )}
                          <Button
                            loading={requestLoading}
                            onClick={() => {
                              const _is_valid = validate();
                              if (!_is_valid) return;
                              setbudgetValues({
                                ...budgetValues,
                                modal: {
                                  type: "save",
                                  copy: false,
                                },
                              });
                            }}
                          >
                            Salvar
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Content>
          ) : (
            <Content>
              <Loading />
            </Content>
          )}
        </Main>
      </PrintPage>
      <ModalConfirm
        confirmText="Quero prosseguir assim mesmo"
        show={dateProblem}
        title={<span style={{ color: "var(--color-error)" }}>Conflitos de Data</span>}
        text={
          <>
            <p>
              A Alteração da data que você selecionou ultrapassa a data da última parcela estabelecida (
              {formatDate(dateProblem?.lastPayment, 2)}). Por favor, revise o plano financeiro da turma antes de
              prosseguir.
            </p>
            <p>Mas se você deseja prosseguir assim mesmo, preecha o campo de segurança para confirmar a sua ação.</p>
          </>
        }
        closeModal={() => {
          setdateProblem();
        }}
        colorScheme="error"
        confirm={async () => {
          dateProblem.next();
          setdateProblem();
        }}
      />
      <ModalConfirm
        loading={requestLoading}
        disableClose={requestLoading}
        show={budgetValues?.modal?.type === "save"}
        title={`${budgetValues?.modal?.copy ? "Copiar Orçamento" : "Salvar Orçamento"}`}
        text={`${
          budgetValues?.modal?.copy
            ? "Deseja salvar as atualizações em um novo orçamento? (Cópia)"
            : "Deseja salvar as atualizações deste orçamento"
        }`}
        options={[
          {
            label: "Não",
            buttonColor: "primary_ghost",
            effect: () => {
              setbudgetValues({
                ...budgetValues,
                modal: null,
              });
            },
          },
          ...(!budgetValues?.main && budgets?.length > 0
            ? [
                {
                  label: "Salvar e torná-lo principal",
                  buttonColor: "button_primary",
                  effect: () => {
                    saveBudget({
                      copy: budgetValues?.modal?.copy,
                      main: true,
                    });
                  },
                },
              ]
            : []),
          {
            label: "Salvar",
            buttonColor: "button_primary",
            effect: () => {
              saveBudget({
                copy: budgetValues?.modal?.copy,
                main: budgetValues?.main,
              });
            },
          },
        ]}
        closeModal={() => {
          setbudgetValues({
            ...budgetValues,
            modal: null,
          });
        }}
        colorScheme="primary"
      />
      <ModalConfirm
        loading={requestLoading}
        disableClose={requestLoading}
        show={budgetValues?.modal?.type === "delete"}
        title="Apagar Orçamento"
        text="Tem certeza que deseja esse orçamento? Essa ação é irreversível!"
        confirmText="Apagar"
        confirm={() => {
          saveBudget({
            delete: true,
          });
          setbudgetValues({
            ...budgetValues,
            modal: null,
          });
        }}
        closeModal={() => {
          setbudgetValues({
            ...budgetValues,
            modal: null,
          });
        }}
        colorScheme="error"
      />
      <ModalBudget
        show={budgetValues?.modal?.type === "others"}
        title="Outras Versões"
        closeModal={() => {
          setbudgetValues({
            ...budgetValues,
            modal: null,
          });
        }}
        selected={budgetSelect}
        budgets={budgets?.filter(__budget => !!__budget.active)}
      />
      <ModalResourceTemplate
        show={!!templates?.category_selected}
        closeModal={() =>
          settemplates({
            ...templates,
            category_selected: null,
          })
        }
        templates={templates?.data?.filter(__template => __template.category_id === templates?.category_selected)}
        addTemplate={__ev => {
          addTemplate(__ev);
        }}
      />
    </>
  );
}
